import React, { useState } from "react";
import { makeStyles } from "@material-ui/core";

import CardNodata from './../../../../../common/cardNoData';
import { actionTypes } from './../../../../../../redux/bourse/report_trade_detail';
import { useDispatch, useSelector } from "react-redux";

import TablesStock from './tables';
import KeysKala from './keysKala';


let useStyles = makeStyles((theme) => ({
    container: {
        width: '45%',
        minHeight: 500,
        [theme.breakpoints.down("1100")]: {
            width: '100%',
            margin: 'auto',
        },
    },
    root: {
        // marginTop: 50,
        width: '100%',
        boxShadow: 'rgba(0, 0, 0, 0.06) 0px 0px 20px 0px',
        borderRadius: 10,
        minHeight: 385,
        backgroundColor: 'rbg(255,255,255)',
        padding: '45px 30px',

        [theme.breakpoints.down("1100")]: {
            width: '100%',
            minHeight: 'auto',
            padding: '20px 10px',
        },

    },
    gridItem: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    cardStock: {
        margin: '5px 0px'
    },
    titleStock: {
        fontWeight: 'bold',
    },
    head: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 20,
        [theme.breakpoints.down("500")]: {
            width: '100%',
            justifyContent: 'center',
            flexDirection: 'column'
        },
    },
    gridBtn: {
        [theme.breakpoints.down("500")]: {
            width: '100%',
            margin: "10px 0px",
        },
    },
    button: {
        backgroundColor: "#E60001",
        color: "white",
        border: 0,
        borderRadius: "8px",
        marginRight: 10,
        width: 90,
        height: 44,
        boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
        [theme.breakpoints.down("md")]: {
            width: 120,
            height: 40,
        },
        [theme.breakpoints.down("500")]: {
            width: '100%',
        },
    },
    buttonDisable: {
        backgroundColor: "gray",
        color: "white",
        border: 0,
        borderRadius: "8px",
        marginRight: 10,
        width: 90,
        height: 44,
        boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
        [theme.breakpoints.down("md")]: {
            width: 120,
            height: 40,
        },
        [theme.breakpoints.down("500")]: {
            width: '100%',
        },
    },
    gridHead: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 20,
        [theme.breakpoints.down("400")]: {
            justifyContent: 'center',
            flexDirection: 'column-reverse'
        },
    },
    DeleteIcons: {
        fill: 'red',
        cursor: 'pointer',
        [theme.breakpoints.down("400")]: {
            marginBottom: 20
        },
    },
    titleHead: {
        fontSize: "1.125rem",
        fontWeight: 'bold',
    }
}))

export default function Index({ stock, setStock, data }) {

    let classes = useStyles();
    let dispatch = useDispatch()

    const [keysStock, setkeysStock] = useState({
        offer_volume: false,
        offer_base_price: false,
        minimum_price: false,
        maximum_price: false,
        final_weighted_average_price: false,
    });

    const stateReducer = useSelector(state => state?.report_trade_detail_reducer)


    function checkAnyTrue(obj) {
        return Object.values(obj).some(value => value === true);
    }


    const apiSubmit = () => {

        // if (!data?.from_date || !data?.to_date) {
        //     alert('لطفا فیلد های تاریخ رو پر نمایید ')
        //     return
        // }
        if (!Object.keys(stock)?.length) {
            alert('لطفا کالای مورد نظر خود را انتخاب نمایید')
            return
        }
        if (!checkAnyTrue(keysStock)) {
            alert('لطفا فیلد مقایسه نظر خود را انتخاب نمایید')
            return
        }

        dispatch(({ type: actionTypes?.reportTradeDetailEmpty }))

        let obj = {}

        let data = Object.keys(stock)?.forEach((value) => {
            obj[stock?.[value]?.body?.offer_symbol] = Object.keys(keysStock).filter(key => keysStock[key]);
        })


        let payload = {
            data:
            {
                offer_symbols: {
                    ...obj
                },
                // from_trade_date:'1402/09/16',
                // to_trade_date:'1402/10/16',
                // from_trade_date: data?.from_date ? dateMiladiToShamsi(data?.from_date?.split(' ')?.[0]) : '',
                // to_trade_date: data?.to_date ?dateMiladiToShamsi(data?.to_date?.split(' ')?.[0]) : '',
            }
        };

        dispatch(({ type: actionTypes?.reportTradeDetailAsync, payload: payload }))
    }



    return (
        <div className={classes['container']}>
            <div className={classes['root']}>
                <div className={classes['head']}>
                    <div>
                        <h3 className={classes['titleHead']}>
                            لیست مقایسه
                        </h3>
                    </div>
                    <div className={classes['gridBtn']}>
                    </div>
                </div>
                <TablesStock
                    data={stock}
                    stock={stock}
                    setStock={setStock}
                />

                {/* {
                Object?.keys(stock)
                    ?.map((itemKey) => {
                        return (
                            <div className={classes['cardStock']}>
                                <hr />
                                <div className={classes['gridHead']}>
                                    <p className={classes['titleStock']}>
                                        {
                                            stock?.[itemKey]?.['data']?.['body']?.['commodity_detail']?.['persianName']
                                        }
                                        {
                                            ` (${itemKey})`
                                        }
                                    </p>
                                    <div >
                                        <Delete
                                            className={classes['DeleteIcons']}
                                            onClick={() => handelDelteStock(itemKey)}
                                        />
                                    </div>
                                </div>
                                <div className={classes['gridItem']}>
                                  
                                </div>
                                <hr />
                            </div>
                        )
                    })
            } */}
                {
                    Object?.keys(stock)?.length === 0 && (
                        <CardNodata
                            text={'لطفا از جدول بالا کالای را انتخاب نمایید'}
                        />
                    )
                }
            </div>
            <KeysKala
                keysStock={keysStock}
                setkeysStock={setkeysStock}
                apiSubmit={apiSubmit}
            />
        </div>
    )
}
